import { makeStyles } from '@material-ui/core';

export const usePreFormValidDniStyles = makeStyles((theme) => ({
  title: {
    fontSize: 16,
    textAlign: 'center',
  },
  paperDialog: {
    borderRadius: 6,
  },
  image: {
    width: (props) => (props.mobile ? 278 : 245),
    height: (props) => (props.mobile ? 173 : 153),
  },
  titleDialog: {
    '&.MuiDialogTitle-root': {
      fontWeight: 600,
      color: `${theme.palette.primary.main}`,
      fontSize: (props) => (props.mobile ? 16 : 22),
      textAlign: (props) => (props.mobile ? 'center' : 'left'),
    },
  },
  contentDialog: {
    '&.MuiDialogContent-root': {
      display: 'flex',
      alignItems: 'center',
      flexDirection: (props) => (props.mobile ? 'column' : null),
    },
  },
  textDialog: {
    '&.MuiDialogContentText-root': {
      fontWeight: 600,
      color: '#000',
      fontSize: (props) => (props.mobile ? 14 : 15),
      marginTop: (props) => (props.mobile ? 10 : 5),
    },
  },
}));
